import { useEffect, useState } from 'react';
import styles from './Toast.module.css';

interface ToastOptions {
    /** Ao clicar no toast, executa esta ação (ex.: navegar). Torna o toast clicável. */
    onClick?: () => void;
    /** Duração em ms antes de sumir. Padrão: 4000 (ou 8000 quando há onClick). */
    duration?: number;
}

interface ToastMessage {
    id: number;
    text: string;
    type: 'success' | 'error' | 'info';
    onClick?: () => void;
}

let addToast: (text: string, type: ToastMessage['type'], options?: ToastOptions) => void = () => {};

export function toast(text: string, type: ToastMessage['type'] = 'info', options?: ToastOptions) {
    addToast(text, type, options);
}

export function Toast() {
    const [messages, setMessages] = useState<ToastMessage[]>([]);

    useEffect(() => {
        addToast = (text, type, options) => {
            const id = Date.now();
            setMessages(prev => [...prev, { id, text, type, onClick: options?.onClick }]);
            const duration = options?.duration ?? (options?.onClick ? 8000 : 4000);
            setTimeout(() => {
                setMessages(prev => prev.filter(m => m.id !== id));
            }, duration);
        };
    }, []);

    if (messages.length === 0) return null;

    const dismiss = (id: number) =>
        setMessages(prev => prev.filter(m => m.id !== id));

    return (
        <div className={styles.container}>
            {messages.map(msg => (
                <div
                    key={msg.id}
                    className={`${styles.toast} ${styles[msg.type]} ${msg.onClick ? styles.clickable : ''}`}
                    onClick={msg.onClick ? () => { msg.onClick?.(); dismiss(msg.id); } : undefined}
                    role={msg.onClick ? 'button' : undefined}
                >
                    <span>{msg.text}</span>
                    <button
                        className={styles.close}
                        onClick={(e) => { e.stopPropagation(); dismiss(msg.id); }}
                    >
                        ×
                    </button>
                </div>
            ))}
        </div>
    );
}
